/**
 * deploysSnapshot — turn the Deploys view's on-screen list into a
 * human-readable SpaContext snapshot (2026-07-01, see+control generalization).
 *
 * Lets the voice ("BRIDGE") and Pi agents SEE this tenant's public deployments
 * (slug · url · status) instead of guessing. Pure + framework-free so it
 * unit-tests directly (mirrors ghlSnapshot / n8nSnapshot).
 */
import type { SpaContext } from '@/stores/spaContextStore';
import type { DeployListItem } from '@/types';

export const DEPLOYS_VIEW_ID = 'deploys';

function plural(n: number, one: string, many: string): string {
  return `${n} ${n === 1 ? one : many}`;
}

/** Build the on-screen snapshot for the Deploys view. */
export function buildDeploysSnapshot(deploys: DeployListItem[]): SpaContext {
  const items = deploys.map((d) =>
    [d.slug || '(no slug)', d.url || '(no url)', `status: ${d.status || 'unknown'}`].join(' · '),
  );
  return {
    view: DEPLOYS_VIEW_ID,
    activeView: DEPLOYS_VIEW_ID,
    title: 'Deployments',
    detail:
      deploys.length === 0
        ? 'No active deployments for this tenant'
        : `${plural(deploys.length, 'active deployment', 'active deployments')} for this tenant`,
    items,
  };
}
